if (!customElements.get('new-arrivals-carousel-slider')) {
  class NewArrivalsCarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.initAttempts = 0;
    }

    connectedCallback() {
      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    getSwiperOptions() {
      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};

      const desktopSlides = Math.min(
        parseFloat(swiperOptions.slidesPerViewDesktop) || 4,
        5
      );

      const options = {
        a11y: false,
        threshold: 3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 4,
        slidesPerView: swiperOptions.slidesPerViewMobile || 1.1,
        slidesPerGroup: 1,
        resistanceRatio: 0.72,
        watchOverflow: true,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewTablet || 2.5,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 4,
            slidesPerGroup: 1
          },
          990: {
            slidesPerView: desktopSlides,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 4,
            slidesPerGroup: 1
          }
        }
      };

      if (swiperOptions.navigation) {
        options.navigation = { ...swiperOptions.navigation };
      }

      if (swiperOptions.scrollbar) {
        options.scrollbar = {
          ...swiperOptions.scrollbar,
          draggable: true
        };
      }

      if (swiperOptions.autoplay) {
        options.autoplay = { ...swiperOptions.autoplay };
      }

      return { options, raw: swiperOptions };
    }

    waitForSwiper() {
      if (window.Swiper) {
        this.initSlider();
        return;
      }

      if (this.initAttempts >= 50) {
        return;
      }

      this.initAttempts += 1;
      setTimeout(() => this.waitForSwiper(), 100);
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider(slider = this) {
      if (this.slider || !window.Swiper) {
        return;
      }

      const { options, raw: swiperOptions } = this.getSwiperOptions();
      this.slider = new window.Swiper(slider, options);

      this.slider.wrapperEl.setAttribute('aria-live', 'polite');
      this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId}`;
      this.slider.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute(
          'aria-label',
          `${i + 1} / ${this.slider.slides.length}`
        );
        slide.dataset.index = i;
      });

      if (swiperOptions.navigation) {
        [this.slider.navigation.prevEl, this.slider.navigation.nextEl].forEach(
          (button, i) => {
            if (!button) {
              return;
            }

            button.setAttribute(
              'aria-label',
              `${i === 1 ? 'Next' : 'Previous'} slide`
            );
            button.setAttribute(
              'aria-controls',
              this.slider.wrapperEl.id
            );
          }
        );
      }

      this.slider.wrapperEl.addEventListener('focusin', (e) => {
        const slide = e.target.closest('.swiper-slide');
        if (!slide) {
          return;
        }

        const slideIndex = +slide.dataset.index;
        this.slider.slideTo(slideIndex, 0);
      });

      this.slider.wrapperEl.addEventListener('mouseenter', () => {
        if (this.slider.autoplay) {
          this.slider.autoplay.stop();
        }
      });

      this.slider.wrapperEl.addEventListener('mouseleave', () => {
        if (
          !this.classList.contains('product--open-on-quick-cart') &&
          this.slider.autoplay
        ) {
          this.slider.autoplay.start();
        }
        if (swiperOptions.autoplay === false && this.slider.autoplay) {
          this.slider.autoplay.stop();
        }
      });

      const refresh = () => {
        if (!this.slider) {
          return;
        }
        this.slider.update();
      };

      requestAnimationFrame(refresh);
      window.addEventListener('load', refresh, { once: true });

      this.querySelectorAll('product-card').forEach((card) => {
        card.init();
      });
    }
  }

  customElements.define(
    'new-arrivals-carousel-slider',
    NewArrivalsCarouselSlider
  );
}
